import Page from './Page';
import Component from 'vue-class-component';

import template from './Menu.vue.html';
import LineModal from './LineModal.vue';
import TabBar from './TabBar.vue';
import HeaderComponent from './Header.vue';
@Component({ template, components: { LineModal, TabBar, HeaderComponent } })
export default class Menu extends Page {
    showNotice = false;
    showLine = false;

    async created() {
        const id = this.app.reserve!.id;
        this.showNotice = !localStorage?.getItem('Mypage:ShownNotice:' + id);
        await this.app.fetchInfo();

        if (this.app.require_agreement) {
            this.app.setPage('Agreement');
            return;
        }

        // 登録未完了かつ登録画面を閲覧していなければ宿泊者情報登録画面へリダイレクト
        const firstGuest = this.firstGuest;
        const alreadyShownFirstGuest = localStorage?.getItem(
            'Mypage:ShownGuest:' + firstGuest?.id
        );
        if (firstGuest && !firstGuest.completed && !alreadyShownFirstGuest) {
            this.app.setQuery({ page: 'Guest', guest_id: firstGuest.id });
            return;
        }
    }

    get firstGuest() {
        return (
            this.app.guestList.find((guest) => guest.is_first) ??
            this.app.guestList[0]
        );
    }

    firstGuestName() {
        return this.firstGuest.name || this.firstGuest.name_kana;
    }

    closeNotice() {
        const id = this.app.reserve!.id;
        localStorage?.setItem('Mypage:ShownNotice:' + id, 'true');
        this.showNotice = false;
    }

    showCode() {
        if (this.app.code) this.app.setPage('Code');
        else this.showNotice = true;
    }

    openGuest(guest: { id: number }) {
        this.app.setQuery({ page: 'Guest', guest_id: guest.id.toString() });
    }

    openGuestInformation(guest: { id: number }) {
        this.app.updateQuery({
            page: 'GuestInformation',
            guest_id: guest.id.toString(),
        });
    }

    back() {
        this.app.setLang(null);
        this.app.setPage('Top');
    }
}
